import HrTicketDetailLayout from './HrTicketDetailLayout';

export default HrTicketDetailLayout;
